export default __webpack_public_path__ + "static/media/Scan.d1378eb5.svg";